import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate  , Route  } from "react-router-dom";
import Header  from './header';
import MUIDataTable from "mui-datatables";
import Rodal from 'rodal';

// include styles
import 'rodal/lib/rodal.css';
//import ProtectedRoute from 'protectedRoutes'

class Dashboard extends Component {

    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:'',bids:[], visible: false, bidID:'',comment:'',
            totalBids:'',totalUsers:'',totalPending:'',AllBids:[],bidStatus:'Auction',openBids: [],
            editBidNo:'',editAucton:'',editTime:'',editDate:'',
            editAmount:'',editBidder:'', bidUpdate:false, bidDelete:false

            
        };

        this.handleSubmit = this.handleSubmit.bind(this); 
    }

    componentDidMount(){
     //{"bids":"8","Users":"2","Pendingbids":"0"}
     let self = this;
     self.getAllRecord()
     var data = [];
          for(var i = 0; i < 100; i++){
       
 
        data.push(
        
          <tr>
          <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Speakers</div></td>
          <td><div className="td-content"><span className="pricing">$84.00</span></div></td>
          <td><div className="td-content"><span className="discount-pricing">$10.00</span></div></td>
          <td><div className="td-content">240</div></td>
          <td><div className="td-content"><a href="javascript:void(0);" className>Direct</a></div></td>
        </tr>
       )     
         }
     self.setState({AllBids:data});
     var getStats = new FormData(); 
     getStats.append('OP', 'getStats');
     axios.post('http://oliac.com/BMSCalls/bids.php',getStats)
     .then(function (response) {
      self.setState({totalBids:response.data.bids , totalUsers:response.data.Users, totalPending:response.data.Pendingbids})
       console.log("STATS",response);
       
     })
     .catch(function (error) {
       console.log(error);
     });
     
    //  navigate = useNavigate();
        var loaderElement = document.querySelector('#load_screen');
        setTimeout( function() {
            loaderElement.style.display = "none";
        }, 3000); 
        self.getAllOpenBids()
      }

      getAllRecord(){
        let self = this;
        var getDetails = new FormData(); 
        getDetails.append('OP', 'getAllOpenBids');
        axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
        .then(function (response) {
          console.log("BIDS",response.data); 
          if((response.data.status== "true" || response.data.status== true) && localStorage.getItem("ROLE") == "Admin" ){
    
            var data = [];
           for(var i = 0; i < response.data.response.length; i++){
           data.push(
              [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
              ,response.data.response[i]['comments'],response.data.response[i]['bidStatus'],<div  onClick={(event) => self.modify(event)}  className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-danger">Delete</span> <span className="badge outline-badge-danger">Edit</span></div>,
               <div onClick={(event) => self.show(event.currentTarget.id)}  className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-primary">Update Comment</span></div>,
            ],
           )
           
          }
          self.setState({openBids:data});
          console.log("YOOO",data); 
         } 
        
        })
         .catch(function (error) {
  
          console.log(error);
  
        });
      }
      modify(e){
        let self = this;
        let ID = e.currentTarget.id;
        let action = e.target.innerHTML;
        if (action=="Edit"){
          this.setState({ comment:'',bidUpdate: true, bidID:ID,bidStatus:'Auction'});
          self.getBidforUpdate(ID);
           // Edit
        }else{
          this.setState({ comment:'',bidDelete: true, bidID:ID});
          // Remove
        }
        //console.log("IID",e.target.innerHTML)
      }
      
      show(ID) {
        
        this.setState({ comment:'',visible: true, bidID:ID,bidStatus:'Auction'});
        
      }
      getAllOpenBids(){
        let self = this;
        var getDetails = new FormData(); 
        getDetails.append('OP', 'getAllOpenBids');
        axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
        .then(function (response) {
          console.log("ALLBIDS",response.data);
          if(response.data.status == "false"){
  
          }else{
            var data = [];
            for(var i = 0; i < response.data.response.length; i++){
         
            //val id = response.data.response[i]['id'];
          data.push(
          //self.setState({ visible: true, bidID: response.data.response[i]['id']}) 
          // <td style={{display: 'none'}}><div className="td-content customer-name">{response.data.response[i]["id"]}</div></td>
          
           <tr>
           <td><div className="td-content customer-name">{response.data.response[i]['bidUser']}</div></td>
           <td><div className="td-content product-brand">{response.data.response[i]['bid_date']}/{response.data.response[i]['bid_time']}</div></td>
           <td><div className="td-content">{response.data.response[i]['bid_auction']}</div></td>
           <td><div className="td-content">{response.data.response[i]['bid_no']}</div></td>
           <td><div className="td-content pricing"><span className>{response.data.response[i]['bid_amount']}</span></div></td>
           <td><div className="td-content"><span className="badge outline-badge-danger">OPEN</span></div></td>
           <td onClick={(event) => self.show(event.currentTarget.id)} id={response.data.response[i]["id"]}><div className="td-content"> <span className="badge outline-badge-success">Add Comment</span></div></td>
           </tr>
         )     
           }
           self.setState({bids:data});
           console.log("YOOO",self.state.bids); 
          }
          
         
         })
         .catch(function (error) {
  
          console.log(error);
  
        });
  
      }

      getBidforUpdate(id){
        let self = this;
        var getDetails = new FormData(); 
        getDetails.append('id', id);
        getDetails.append('OP', 'getBidforUpdate');
        axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
        .then(function (response) {

        // 

          self.setState({editBidNo:response.data.response[0].bid_no,
            editAucton:response.data.response[0].bid_auction,
            editTime:response.data.response[0].bid_time,
            editDate:response.data.response[0].bid_date,
          editAmount:response.data.response[0].bid_amount,
          editBidder:response.data.response[0].bidding_user })
          //console.log("ALLBIDS",self.state.editBidNo);
          /*  
            editBidNo:'',editAucton:'',editTime:'',editDate:'',
            editAmount:'',editBidder:'' 
          */
         })
         .catch(function (error) {
  
          console.log(error);
  
        });
  
      }
   

    updateComment(event){

        this.setState({comment:event.target.value})
        
      }

    updateUsername(event){
        this.setState({username:event.target.value})
        console.log(this.state.username);

    } 

    addComment(){
      let self = this;
      var addComment = new FormData();
      addComment.append('id', this.state.bidID);
      addComment.append('comment', this.state.comment);
      addComment.append('bidStatus', this.state.bidStatus);
      addComment.append('OP', 'updateComment');
      axios.post('http://oliac.com/BMSCalls/bids.php',addComment)
      .then(function (response) {

        console.log("COMMENT",response);
        self.hide()
        self.getAllOpenBids()
        self.getAllRecord()
        toast.success('Comment Updated', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          closeButton:false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
       
      })
      .catch(function (error) {
        console.log(error);
      });
    }
     
    hide() {
      this.setState({ visible: false });
    }
    updatePassword(event){
         
        this.setState({password:event.target.value})
        console.log(this.state.password);

    }
    updateEditDate(event){
      this.setState({editDate:event.target.value})
    }


    updateEditTime(event){
      this.setState({editTime:event.target.value})
    }

    updateEditAuction(event){
      this.setState({editAucton:event.target.value})
    }


    updateEditAmount(event){
      this.setState({editAmount:event.target.value})
    }

    updateEditBidNumber(event){
      this.setState({editBidNo:event.target.value})
    }

    deleteRecord(){
      let self = this;
      console.log("BIDS",this.state.editAmount+
      this.state.editAucton+this.state.editBidNo+
      this.state.editDate+this.state.editTime)
      
      var getDetails = new FormData(); 
      getDetails.append('id', this.state.bidID); 
      getDetails.append('OP', 'deleteBid');
      axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
      .then(function (response) {
        console.log("Comments",response.data); 
        
        if(response.data.status== "true" || response.data.status== true){
          self.setState({ bidDelete: false})
          //self.hide()
          self.getAllOpenBids()
          self.getAllRecord()
        
        toast.success('Bid Deleted', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          closeButton:false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      
       }
      
      })
       .catch(function (error) {

        console.log(error);

      });
    }
    updateRecord(){
      let self = this;
      console.log("BIDS",this.state.editAmount+
      this.state.editAucton+this.state.editBidNo+
      this.state.editDate+this.state.editTime)
      
      var getDetails = new FormData(); 
      getDetails.append('id', this.state.bidID);
      getDetails.append('date', this.state.editDate);
      getDetails.append('time', this.state.editTime);
      getDetails.append('bid_auction', this.state.editAucton);
      getDetails.append('bid_no', this.state.editBidNo);
      getDetails.append('bid_amount', this.state.editAmount); 
      getDetails.append('bidding_date', this.state.editDate+" "+this.state.editTime);
      getDetails.append('OP', 'updateBid');
      axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
      .then(function (response) {
        console.log("Comments",response.data); 
        
        if(response.data.status== "true" || response.data.status== true){
          self.setState({ bidUpdate: false})
          //self.hide()
          self.getAllOpenBids()
          self.getAllRecord()
        
        toast.success('Bid Updated', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          closeButton:false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      
       }
      
      })
       .catch(function (error) {

        console.log(error);

      });
    }

    handleSubmit(event) {
        if(this.state.password.length > 0 && this.state.username.length>0){
            var loginDetails = new FormData();
            loginDetails.append('email', this.state.username);
            loginDetails.append('password', this.state.password);
            loginDetails.append('OP', 'loginUser');
            axios.post('http://127.0.0.1/BMS/my-app/API/users.php',loginDetails)
              .then(function (response) {
                console.log(response.data.status);
                if(response.data.status =='true'){
                    toast.success('Logging In', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }else{
                    toast.error(response.data.response, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }
              })
              .catch(function (error) {
                console.log(error);
              });
        }else{
            toast.error("Insufficient Details", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                closeButton:false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
        }
      
          
        event.preventDefault();
      }

      changeStatus(e){
        this.setState({bidStatus:e.target.value})
        console.log(this.state.bidStatus)
      }
    
    render (){
      let username = localStorage.getItem("NAME");
      let columns;
      if(localStorage.getItem("ROLE") == "Admin"){ 
       columns = [
       {
        name: "Date",
        label: "Date",
        options: {
         filter: true,
         sort: true,
        }
       },
       {
        name: "Time",
        label: "Time",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
        name: "Bidder",
        label: "Bidder",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
        name: "Auction",
        label: "Auction",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
         name: "Bid No",
         label: "Bid No",
         options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { color: "Red", fontWeight:'600'}}),
         }
        },
       {
         name: "Amount",
         label: "Amount",
         options: {
          filter: false,
          sort: false,
         }
        },
        {
         name: "Comment",
         label: "Comment",
         options: {
          filter: false,
          sort: false,
         }
        },{
          name: "Bid Status",
          label: "Bid Status",
          options: {
           filter: false,
           sort: false,
          }
         },
       
        {
         name: "Action",
         label: "Action",
         options: {
          filter: false,
          sort: false,
         }
        },
        

        {
         name: "Edit Comment",
         label: "Edit Comment",
         options: {
          filter: false,
          sort: false,
         }
        },


      ];}else{
       columns = [
         {
          name: "Date",
          label: "Date",
          options: {
           filter: true,
           sort: true,
          }
         },
         {
          name: "Time",
          label: "Time",
          options: {
           filter: true,
           sort: false,
          }
         },
         {
          name: "Bidder",
          label: "Bidder",
          options: {
           filter: true,
           sort: false,
          }
         },
         {
          name: "Auction",
          label: "Auction",
          options: {
           filter: true,
           sort: false,
          }
         },
         {
           name: "Bid No",
           label: "Bid No",
           options: {
            filter: false,
            sort: false,
           }
          },
         {
           name: "Amount",
           label: "Amount",
           options: {
            filter: false,
            sort: false,
           }
          },
          {
           name: "Comment",
           label: "Comment",
           options: {
            filter: false,
            sort: false,
           }
          },
         
          {
           name: "Action",
           label: "Action",
           options: {
            filter: false,
            sort: false,
           }
          },
          {
           name: "Bid Status",
           label: "Bid Status",
           options: {
            filter: true,
            sort: false,
           }
          },


        ]; 
      }
       
       const data = [
         ["Joe James", "Test Corp", "Yonkers", "NY"],
         ["John Walsh", "Test Corp", "Hartford", "CT"],
         ["Bob Herm", "Test Corp", "Tampa", "FL"],
         ["James Houston", "Test Corp", "Dallas", "TX"],
         ];
 
    //  console.log("real",data)

       const options = {
       pageSize:20,
       selectableRows: false,
       filterType: 'none',
       print: false,
       count: 20,
       filter: false, 
       search:false

       };
      
      //  const {products, addToCart, symbol, addToWishlist, addToCompare} = this.props;
      if(localStorage.getItem("ROLE") == "Admin" &&  localStorage.getItem("isAuth") == "true"){  return (
        <div>

            {/* BEGIN LOADER */}
                <div id="load_screen"> <div className="loader"> <div className="loader-content">
                  <div className="spinner-grow align-self-center" />
            </div></div></div>
            {/*  END LOADER */}
        
          <Header/>
          <ToastContainer />
          {/*  END NAVBAR  */}
          {/*  BEGIN MAIN CONTAINER  */}
          <div className="main-container" id="container">
            <div className="overlay" />
            <div className="search-overlay" />
            {/*  BEGIN CONTENT PART  */}
            <div id="content" className="main-content">
              <div className="layout-px-spacing">
                <div className="page-header">
                  <div className="page-title">
                  <h3> <span id="header_welcome">Welcome </span> {username}: </h3>
                  </div>
                  <div className="toggle-switch">
                    <label className="switch s-icons s-outline  s-outline-secondary">
                      <input type="checkbox" defaultChecked className="theme-shifter" />
                      {/* <span className="slider round">
                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-sun"><circle cx={12} cy={12} r={5} /><line x1={12} y1={1} x2={12} y2={3} /><line x1={12} y1={21} x2={12} y2={23} /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1={1} y1={12} x2={3} y2={12} /><line x1={21} y1={12} x2={23} y2={12} /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" /></svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>
                      </span> */}
                    </label>
                  </div>
                </div>
                <div className="row layout-top-spacing">
                                  
                  <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget-three">
                      <div className="widget-heading">
                        <h5 className>Summary</h5>
                      </div>
                      <div className="widget-content">
                        <div className="order-summary">
                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1={3} y1={6} x2={21} y2={6} /><path d="M16 10a4 4 0 0 1-8 0" /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Total Bids</h6>
                                <p className="summary-count">{this.state.totalBids}</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-secondary" role="progressbar" style={{width: '90%'}} aria-valuenow={90} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-tag"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1={7} y1={7} x2={7} y2={7} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Approved Bids</h6>
                                <p className="summary-count">{parseInt(this.state.totalBids) - parseInt(this.state.totalPending) }</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-success" role="progressbar" style={{width: '65%'}} aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card"><rect x={1} y={4} width={22} height={16} rx={2} ry={2} /><line x1={1} y1={10} x2={23} y2={10} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Pending Bids</h6>
                                <p className="summary-count">{this.state.totalPending}</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-warning" role="progressbar" style={{width: '80%'}} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card"><rect x={1} y={4} width={22} height={16} rx={2} ry={2} /><line x1={1} y1={10} x2={23} y2={10} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Pending Bids</h6>
                                <p className="summary-count">5,085</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-warning" role="progressbar" style={{width: '80%'}} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div> */}

                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card"><rect x={1} y={4} width={22} height={16} rx={2} ry={2} /><line x1={1} y1={10} x2={23} y2={10} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Users</h6>
                                <p className="summary-count">{this.state.totalUsers}</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-warning" role="progressbar" style={{width: '80%'}} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-activity-four">
                      <div className="widget-heading">
                        <h5 className>Recent Activities</h5>
                      </div>
                      <div className="widget-content">
                        <div className="mt-container mx-auto">
                          <div className="timeline-line">
                            <div className="item-timeline timeline-primary">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p><span>Updated</span> Server Logs</p>
                                <span className="badge badge-danger">Pending</span>
                                <p className="t-time">Just Now</p>
                              </div>
                            </div>
                            <div className="item-timeline timeline-success">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Send Mail to <a href="javascript:void(0);">HR</a> and <a href="javascript:void(0);">Admin</a></p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">2 min ago</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-danger">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Backup <span>Files EOD</span></p>
                                <span className="badge badge-danger">Pending</span>
                                <p className="t-time">14:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-dark">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Collect documents from <a href="javascript:void(0);">Sara</a></p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">16:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-warning">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Conference call with <a href="javascript:void(0);">Marketing Manager</a>.</p>
                                <span className="badge badge-primary">In progress</span>
                                <p className="t-time">17:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-secondary">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Rebooted Server</p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">17:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-warning">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Send contract details to Freelancer</p>
                                <span className="badge badge-danger">Pending</span>
                                <p className="t-time">18:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-dark">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Kelly want to increase the time of the project.</p>
                                <span className="badge badge-primary">In Progress</span>
                                <p className="t-time">19:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-success">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Server down for maintanence</p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">19:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-secondary">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Malicious link detected</p>
                                <span className="badge badge-warning">Block</span>
                                <p className="t-time">20:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-warning">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Rebooted Server</p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">23:00</p>
                              </div>
                            </div>
                          </div>                                    
                        </div>
                        <div className="tm-action-btn">
                          <button className="btn">View All <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg></button>
                        </div>
                      </div>
                    </div>
                  </div> */}
              
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-table-two">
                      <div className="widget-heading">
                        <h5 className>Recent Bids</h5>
                      </div>
                      <MUIDataTable
                      title={"All Bids"}
                      data={this.state.openBids}
                      columns={columns}
                      options={options}
                      />
                      <br/>
                      <Rodal visible={this.state.visible} onClose={this.hide.bind(this)}>
                 <div>  

                 <h2>Add Comment</h2>
                 <input type="text" className="form-control"  
                  placeholder="Comment"  value= {this.state.comment}
                    onChange={(e) => {this.updateComment(e)}}  />

                 <input type="hidden" 
                 className="form-control" 
                  
                  placeholder="Comment" value= {this.state.bidID} 
                  

                  />
 
                  <select className="form-control basic" style={{marginTop:'10px'}} onChange={ (e) => this.changeStatus(e)}>

                  <option>Auction</option>

                  <option>Purchased</option>
                          
                  <option>Sold</option>

                  <option>Not Sold</option>

                  <option>Cancelled</option>
                          
                  </select> 

                 <button type="button" id="btnRegis" className="btn btn-primary mt-4" onClick={() => this.addComment()}>Add Comment</button>

                 </div>
                 </Rodal>



                 <Rodal visible={this.state.bidUpdate} onClose={()=>{ this.setState({  bidUpdate: false });}} height={500} width={450}>
                 <div>  

                 <h2>Edit Details</h2>
                 <input type="text" className="form-control"  
                  placeholder="Date" style={{marginBottom:'10px',marginTop:'10px',marginRight:'10px'}}
                  value={this.state.editDate}   onChange={(e) => {this.updateEditDate(e)}}  />
 
                  <input type="text" className="form-control"  
                  placeholder="Time"   value={this.state.editTime}
                  onChange={(e) => {this.updateEditTime(e)}}
                   style={{marginBottom:'10px',marginTop:'10px',marginRight:'10px'}}  />
 
                <input type="text" className="form-control"  
                  placeholder="Auction"
                  onChange={(e) => {this.updateEditAuction(e)}} value={this.state.editAucton}  style={{marginBottom:'10px',marginTop:'10px',marginRight:'10px'}} />

                <input type="text" className="form-control"  
                  placeholder="Bid Number"
                  onChange={(e) => {this.updateEditBidNumber(e)}} value={this.state.editBidNo} style={{marginBottom:'10px',marginTop:'10px',marginRight:'10px'}}  />

                <input type="text" className="form-control"  
                  placeholder="Amount" 
                  onChange={(e) => {this.updateEditAmount(e)}} value={this.state.editAmount} style={{marginBottom:'10px',marginTop:'10px',marginRight:'10px'}}  />
 

                 <input type="hidden" 
                 className="form-control" placeholder="Comment" value= {this.state.bidID}  />
 
                
                 <button type="button" id="btnRegis" className="btn btn-primary mt-4" onClick={() => this.updateRecord()}>Update Record</button>

                 </div>
                 </Rodal>


                 
                 <Rodal visible={this.state.bidDelete} onClose={()=>{ this.setState({  bidDelete: false });}}>
                 <div>  

                 <h2>Are you Sure, You want to delete record?</h2>
                 
                 <input type="hidden" 
                 className="form-control" placeholder="Comment" value= {this.state.bidID}  />
 
                
                 <button type="button" id="btnRegis" className="btn btn-primary mt-4" onClick={() => this.deleteRecord()}>Update Record</button>

                 </div>
                 </Rodal>
                  </div>
                  </div>
                  {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-table-three">
                      <div className="widget-heading">
                        <h5 className>Recent Users</h5>
                      </div>
                       <div className="widget-content">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th><div className="th-content">Bidder</div></th>
                                <th><div className="th-content">Bid Date/Time</div></th>
                                <th><div className="th-content">Auction</div></th>
                                <th><div className="th-content th-heading">Bid Number</div></th>
                                <th><div className="th-content th-heading">Bid Amount</div></th>
                                <th><div className="th-content">Status</div></th>
                                <th><div className="th-content">Add Comment</div></th>
                              </tr>
                            </thead>
                            <tbody>
                            {/* {
    this.state.bids.map((row, j) => (
    <tr>
      {row.map((val) => (
        <td>{val}</td>
      ))}
    </tr>
  ))
}
           */}
       
     {/*    <tr>
        <td><div className="td-content customer-name">Laurie Fox</div></td>
        <td><div className="td-content product-brand">Camera</div></td>
        <td><div className="td-content">#66894</div></td>
        <td><div className="td-content pricing"><span className>$126.04</span></div></td>
        <td><div className="td-content"><span className="badge outline-badge-danger">Pending</span></div></td>
        </tr>
        
  
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Andy King</div></td>
                                <td><div className="td-content product-brand">Nike Sport</div></td>
                                <td><div className="td-content">#76894</div></td>
                                <td><div className="td-content pricing"><span className>$88.00</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-primary">Shipped</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Irene Collins</div></td>
                                <td><div className="td-content product-brand">Speakers</div></td>
                                <td><div className="td-content">#75844</div></td>
                                <td><div className="td-content pricing"><span className>$84.00</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-success">Paid</span></div></td>
                              </tr>
                             
                               <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Luke Ivory</div></td>
                                <td><div className="td-content product-brand">Headphone</div></td>
                                <td><div className="td-content">#46894</div></td>
                                <td><div className="td-content pricing"><span className>$56.07</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-success">Paid</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Ryan Collins</div></td>
                                <td><div className="td-content product-brand">Sport</div></td>
                                <td><div className="td-content">#89891</div></td>
                                <td><div className="td-content pricing"><span className>$108.09</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-primary">Shipped</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Nia Hillyer</div></td>
                                <td><div className="td-content product-brand">Sunglasses</div></td>
                                <td><div className="td-content">#26974</div></td>
                                <td><div className="td-content pricing"><span className>$168.09</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-primary">Shipped</span></div></td>
                              </tr>
                            <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Sonia Shaw</div></td>
                                <td><div className="td-content product-brand">Watch</div></td>
                                <td><div className="td-content">#76844</div></td>
                                <td><div className="td-content pricing"><span className>$110.00</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-success">Paid</span></div></td>
                              </tr>  
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="widget-content">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th><div className="th-content">Product</div></th>
                                <th><div className="th-content th-heading">Price</div></th>
                                <th><div className="th-content th-heading">Discount</div></th>
                                <th><div className="th-content">Sold</div></th>
                                <th><div className="th-content">Source</div></th>
                              </tr>
                            </thead>
                            <tbody>
                            {this.state.AllBids}
                            <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Speakers</div></td>
                                <td><div className="td-content"><span className="pricing">$84.00</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$10.00</span></div></td>
                                <td><div className="td-content">240</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Direct</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Sunglasses</div></td>
                                <td><div className="td-content"><span className="pricing">$56.07</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$5.07</span></div></td>
                                <td><div className="td-content">190</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Google</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Watch</div></td>
                                <td><div className="td-content"><span className="pricing">$88.00</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$20.00</span></div></td>
                                <td><div className="td-content">66</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Ads</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Laptop</div></td>
                                <td><div className="td-content"><span className="pricing">$110.00</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$33.00</span></div></td>
                                <td><div className="td-content">35</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Email</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Camera</div></td>
                                <td><div className="td-content"><span className="pricing">$126.04</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$26.04</span></div></td>
                                <td><div className="td-content">30</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Referral</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Shoes</div></td>
                                <td><div className="td-content"><span className="pricing">$108.09</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$47.09</span></div></td>
                                <td><div className="td-content">130</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Google</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Headphone</div></td>
                                <td><div className="td-content"><span className="pricing">$168.09</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$60.09</span></div></td>
                                <td><div className="td-content">170</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Ads</a></div></td>
                              </tr>  
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="footer-wrapper">
                  <div className="footer-section f-section-1">
                    <p className>Copyright © 2022 <a target="_blank" href="#">Oliac Japan</a>, All rights reserved.</p>
                  </div>
                  <div className="footer-section f-section-2">
                    <p className>Coded with <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg></p>
                  </div>
                </div>
              </div>
            </div>
            {/*  END CONTENT PART  */}
          </div>
          {/* END MAIN CONTAINER */}
          {/* BEGIN GLOBAL MANDATORY SCRIPTS */}
          {/* END GLOBAL MANDATORY SCRIPTS */}
          {/* BEGIN PAGE LEVEL PLUGINS/CUSTOM SCRIPTS */}
          {/* BEGIN PAGE LEVEL PLUGINS/CUSTOM SCRIPTS */}
        </div>
      );    }else{  return("Unauthorized Access")}
     
    }
}
const mapStateToProps = (state) => ({
 
})
 
export default Dashboard; 